// Close other accordions when one is opened
document.addEventListener('DOMContentLoaded', function() {
  const accordionContainers = document.querySelectorAll('.collapsible-content');

  accordionContainers.forEach(container => {
    const details = container.querySelectorAll('details');

    details.forEach(targetDetail => {
      targetDetail.addEventListener('toggle', function() {
        if (targetDetail.open) {
          // Close all other details in the same container
          details.forEach(detail => {
            if (detail !== targetDetail && detail.open) {
              detail.open = false;
            }
          });
        }
      });
    });
  });
});
